"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePagingOptions = makePagingOptions;

var _consts = require("../consts");

/**
 * Creates dataserver standard paging options object
 * @param currentPage
 * @param recordsPerPage
 * @returns {{PageIndex: number, RecordsPerPage: number}}
 */
function makePagingOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$currentPage = _ref.currentPage,
      currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
      _ref$recordsPerPage = _ref.recordsPerPage,
      recordsPerPage = _ref$recordsPerPage === void 0 ? _consts.DEFAULT_RECORDS_PER_PAGE : _ref$recordsPerPage;

  return {
    PageIndex: currentPage,
    RecordsPerPage: recordsPerPage
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/gfrl/utils/paging-options.js
// module id = 245
// module chunks = 0